import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';
import { useAnchorable } from '../../hooks/useAnchorable';
import { genericEmbed, genericEmbedChildrenContainer, genericEmbedContainer } from './GenericEmbed.css';
import type { TPostGenericEmbedProps } from './GenericEmbed.types';

export const PostGenericEmbed = ({
  element,
  children,
  rewriteImageSrc,
  isIndexingDisabled,
}: TPostGenericEmbedProps) => {
  const { variant, url, target, imageUrl } = element.attrs;
  const { anchorAttributes } = useAnchorable(element.attrs);
  const { utmParams } = usePostContentContext();
  const urlWithUTMParams = evaluateAndAppendUTMParams(url, utmParams);

  const alteredImageUrl = imageUrl && rewriteImageSrc ? rewriteImageSrc(imageUrl) : imageUrl;

  return (
    <div {...anchorAttributes} className={genericEmbedContainer}>
      <a
        href={urlWithUTMParams}
        target={target === '_self' ? undefined : '_blank'}
        rel={isIndexingDisabled ? 'noreferrer' : undefined}
      >
        <div className={genericEmbed}>
          {variant === 'image-top-text-bottom' && (
            <div className="pb-[12px]">
              <img src={alteredImageUrl} className="w-full" alt="" />
            </div>
          )}

          <div className="min-h-[75px] border-collapse w-full flex flex-col-reverse sm:flex-row">
            {variant === 'image-left-text-right' && (
              <div className="w-full pb-[--wt-hyperlink-padding] sm:pr-[--wt-hyperlink-padding] sm:w-[35%] flex items-center">
                <img src={alteredImageUrl} className="w-full h-auto object-cover" alt="" />
              </div>
            )}

            <div className={genericEmbedChildrenContainer}>{children}</div>

            {variant === 'text-left-image-right' && (
              <div className="w-full pb-[--wt-hyperlink-padding] sm:pl-[--wt-hyperlink-padding] sm:w-[35%] flex items-center">
                <img src={alteredImageUrl} className="w-full h-auto object-cover" alt="" />
              </div>
            )}
          </div>
        </div>
      </a>
    </div>
  );
};
